import { axios } from "common";

export const apiIgState = ({ plantId }) => {
  return axios.get("/device/igstate", {
    params: {
      plantId,
    },
  });
};
